import React, { useState, useEffect, useMemo } from "react";
import {
  Col,
  Row,
  Steps,
  Form,
  Button,
  message,
  Space,
  Card,
  Spin,
  Popconfirm,
} from "antd";

import {
  StudentInfo,
  ParentGaurdian,
  EmergencyContact,
  Uploads,
} from "./form_groups";
import dayjs from "dayjs";
import ValuesStore from "../../store/values-store";
import Utilities from "../../dependencies/custom/react-utilities";
import { useNavigate, useLocation } from "react-router-dom";
import Settings from "../../dependencies/custom/settings";
import PrintPreview from "../../components/comps/print_preview";
import CustomFunctions from "../../dependencies/custom/custom-functions";
import SurePayPaymentModal from "../../components/finance/payments/SurePayPaymentModal";
// import useDrawer from "../../hooks/drawer";
// import useModal from "../../hooks/modal";
const { Step } = Steps;

const AdmissionForm = () => {
  const [formLoading, setFormLoading] = useState(false);
  const navigate = useNavigate();
  const valuesStore = ValuesStore();
  const [current, setCurrent] = useState(0);
  const [form] = Form.useForm();
  const [admissionID, setAdmissionID] = useState();
  const [formDBInfoGroups, setFormDBInfoGroups] = useState();
  const [fileList, setFileList] = useState([]); //for holding currently upload files
  const [filesFromDB, setFilesFromDB] = useState([]); //for fetched files
  const [locked, setLocked] = useState(0);
  const { state } = useLocation();
  const [disabled, setDisabled] = useState(false);
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  // const drawer = useDrawer();
  // const modal = useModal();
  const currentPageIndex = "currentPageIndex";
  // console.log(formDBInfoGroups)
  const preview = (
    <PrintPreview
      applicant={formDBInfoGroups?.student}
      parent={formDBInfoGroups?.guardian}
      emergency={formDBInfoGroups?.emergency}
      files={{ filesFromDB, categoryRules: CustomFunctions.categoryRules }}
      admissionID={admissionID}
      bootstrap={bootstrap}
    />
  );

  const shouldSubmitWithoutPayment = useMemo(() => {
    const applicationStatus = formDBInfoGroups?.get_application?.status;
    const hasPaid = parseInt(formDBInfoGroups?.get_application?.hasPaid || 0);
    return applicationStatus === "ADMITTED" || hasPaid === 1;
  }, [formDBInfoGroups]);

  const steps = [
    { ...StudentInfo(form, valuesStore) },
    { ...ParentGaurdian(form, valuesStore) },
    { ...EmergencyContact(form, valuesStore) },
    {
      ...Uploads(
        form,
        filesFromDB,
        fileList,
        setFileList,
        removeFile,
        CustomFunctions.categoryRules,
        locked,
      ),
    },
    {
      title: "Review & Submit",
      content: preview,
      endpoint: "",
    },
  ];

  useEffect(() => {
    form.setFieldsValue({
      countryCodeEmg: "+256",
      countryCodePri: "+256",
      countryCodeAlt: "+256",
    });
    //if the localstorage for the current page exists, set it
    const cpi = sessionStorage.getItem(currentPageIndex);

    if (cpi) {
      setCurrent(parseInt(cpi));
    }

    const admissionData = state?.admissionData;
    const admID = admissionData?.admissionID;

    if (!admissionID) {
      setAdmissionID(admID);
    }

    bootstrap(admID);

    console.log("looping");
  }, []);

  async function bootstrap(admissionID) {
    setFormLoading(true);
    const result = await CustomFunctions.getDataFromDB(admissionID, navigate);
    const {
      data = null,
      dataInGroups = null,
      uploadedFiles = null,
    } = result || {};
    const uf = CustomFunctions.setFilesObject(uploadedFiles);
    setFilesFromDB(uf);
    if (!data) {
      setFormLoading(false);
      return;
    }
    const dob = data?.dob;
    const parsed = dayjs(dob);
    if (parsed.isValid()) {
      form.setFieldsValue({ dob: parsed });
      const age = dayjs().diff(dob, "year");
      form.setFieldValue("age", age);
    }
    delete data["dob"];
    form.setFieldsValue(data);
    setFormDBInfoGroups(dataInGroups);
    setFormLoading(false);
    const l = parseInt(dataInGroups?.get_application?.locked);
    setLocked(l);
    const isAdmitted = dataInGroups?.get_application?.status === "ADMITTED";
    if (l || isAdmitted) {
      setDisabled(true);
      setCurrent(steps.length - 1);
      // navigate('../my_applications');
    }
  }

  async function removeFile(file) {
    //remove file based on ID and not admissionID
    // console.log(file);return;
    if (!file.fromBackend) return;
    await Utilities.fetchWithAuth(
      "DELETE",
      `${Settings.urls.enrollment.uploads}/${file?.id}`,
      { id: file?.id },
      navigate,
    );
  }

  const next = async () => {
    setFormLoading(true);
    try {
      await form.validateFields();
      const res = await save();
      // console.log(res)
      setFormLoading(false);
      if (!res?.ok) {
        setFormLoading(false);
        Utilities.showNotification(undefined, res?.msg);
        return;
      }
      setCurrent((current) => {
        const n = current + 1;
        sessionStorage.setItem(currentPageIndex, n);
        return n;
      });
    } catch (error) {
      console.log(error);
      message.error("Please fill all required fields before continuing");
    }
    setFormLoading(false);
  };

  const prev = () =>
    setCurrent((current) => {
      const n = current - 1;
      sessionStorage.setItem(currentPageIndex, n);
      return n;
    });

  async function saveFiles(endpoint, files) {
    for (let file of files) {
      if (file?.fromBackend) continue;
      const fileObject = file;
      const object = {
        admissionID,
        fileType: fileObject?.category,
        fileName: fileObject?.name,
        files: fileObject?.originFileObj,
      };
      await Utilities.fetchWithAuth("POST", endpoint, object, navigate);
    }
  }

  async function save() {
    // console.log(admissionID)
    const allValues = form.getFieldsValue(); //contains all field values irrespective of the form broken into steps
    const currentForm = steps[current];
    const { endpoint, fields, name } = currentForm || {};
    const values = getCurrentFormValues(fields, allValues);

    if (name === "uploads") {
      await saveFiles(endpoint, fileList);
      return { ok: true }; //required to move to the next page

      //Old implementation
      // for (let file in allValues) {
      //   if (allValues[file]) {
      //     const fileObject = allValues[file][0];
      //     const object = { admissionID, fileType: file, fileName: fileObject?.name, files: fileObject?.originFileObj };
      //     const res = await Utilities.fetchWithAuth('POST', endpoint, object, navigate);
      //   }
      // }
    } else {
      const res = await Utilities.fetchWithAuth(
        "POST",
        endpoint,
        { ...values, admissionID },
        navigate,
      );
      valuesStore.updateObjectValue(
        "user",
        "admissionID",
        res?.data?.admissionID,
      );
      setAdmissionID(res?.data?.admissionID); //update admission id
      return res;
    }
  }

  function getCurrentFormValues(fields, allValues) {
    let values = {};
    fields?.forEach((v) => {
      if (allValues[v]) {
        if (v === "dob") {
          values[v] = dayjs(allValues[v]).format("YYYY-MM-DD");
        } else {
          values[v] = allValues[v];
        }
      }
    });
    return values;
  }

  async function submitApplication() {
    setFormLoading(true);
    const res = await Utilities.fetchWithAuth(
      "POST",
      Settings.urls.enrollment.submit,
      { admissionID },
      navigate,
    );
    if (res.ok) {
      setLocked(1);
      sessionStorage.removeItem(currentPageIndex);
      Utilities.showNotification(undefined, res?.data?.message, "text-success");
      await bootstrap(admissionID);
    } else {
      Utilities.showNotification(
        undefined,
        JSON.parse(res?.msg || "{}")?.message,
      );
    }
    setFormLoading(false);
  }

  async function submit() {
    if (!shouldSubmitWithoutPayment) {
      setPaymentModalOpen(true);
      return;
    }

    await submitApplication();
  }
  // console.log(formDBInfoGroups);
  return (
    <>
      <Row gutter={[24, 0]}>
        <Col xs={24} sm={24} md={12} lg={12} xl={20} className="mb-24">
          <Card
            bordered={false}
            className="criclebox h-full rounded-2xl shadow"
          >
            <Spin spinning={formLoading}>
              <Steps current={current}>
                {steps.map((item) => (
                  <Step key={item.title} title={item.title} />
                ))}
              </Steps>
              <div style={{ marginTop: 20 }}>
                <Form
                  disabled={
                    !!locked ||
                    formDBInfoGroups?.get_application?.status === "ADMITTED"
                  }
                  form={form}
                  layout="vertical"
                  style={{ marginTop: 30 }}
                  // onValuesChange={handleAutoSave}
                  // onFinish={onFinish}
                  key="admission"
                  name="admission"
                >
                  {steps[current]?.content}
                </Form>
              </div>

              <Space style={{ marginTop: 30 }}>
                {current > 0 && (
                  <Button disabled={disabled} onClick={prev}>
                    Previous
                  </Button>
                )}
                {current < steps.length - 1 && (
                  <Button
                    disabled={disabled}
                    type="primary"
                    loading={formLoading}
                    onClick={next}
                  >
                    Next
                  </Button>
                )}
                {current === steps.length - 1 && (
                  <Space>
                    <Popconfirm
                      disabled={!!locked || !!disabled}
                      title="Are you sure you want to submit?"
                      description="Once submitted, you will not be able to make any changes to your application."
                      onConfirm={submit}
                      okText="Yes, Submit"
                      cancelText="Go Back"
                    >
                      <Button
                        disabled={!!locked || !!disabled}
                        type="primary"
                        loading={formLoading}
                        icon={<i className="fas fa-save" />}
                      >
                        {locked
                          ? "Submitted"
                          : shouldSubmitWithoutPayment
                            ? "Submit"
                            : "Pay & Submit"}
                      </Button>
                    </Popconfirm>
                    {/* <PaystackPayment className="ant-btn css-dev-only-do-not-override-mzwlov ant-btn-primary" /> */}
                  </Space>
                )}
              </Space>
            </Spin>
          </Card>
        </Col>
      </Row>
      <SurePayPaymentModal
        open={paymentModalOpen}
        onClose={() => setPaymentModalOpen(false)}
        onSuccess={async () => {
          setPaymentModalOpen(false);
          await submitApplication();
        }}
        paymentCode={formDBInfoGroups?.get_application?.applicationCode}
        codeType="APC"
        amount={formDBInfoGroups?.get_application?.amount}
        description="Admission Fee Payment"
        studentName={`${formDBInfoGroups?.student?.firstName || ""} ${formDBInfoGroups?.student?.lastName || ""}`.trim()}
        feeLabel="Admission Fee"
        title="Pay Admission Fee"
      />
    </>
  );
};

export default AdmissionForm;
